<template>
  <div class="report-ve-awards">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <ContentHeader :name="$route.name"></ContentHeader>
        <div class="row" id="nominations">
          <div class="col-sm-6">
            <div class="alert alert-primary text-center" role="alert">
              Nominations: {{totalPosts}}
            </div>
          </div>
          <div class="col-sm-6">
            <div class="mr-2 float-right alert alert-success text-center" role="alert">
              Download current view as:
              <a href="http://108.128.243.62/wp-content/uploads/reports/CompleteHigh5.csv" target="_Blank">
                <i class="fas fa-file-excel fa-2x" v-b-tooltip.hover title="Download as a CSV file"></i>
              </a>
            </div>
          </div>
        </div>
        <NominationReportEntries v-if="nominations.length > 0" :nominations="nominations"></NominationReportEntries>
        <span v-if="nominations.length === 0">
          No nominations have been submitted
        </span>
        <div class="row">
          <div class="col-sm-6 mt-3">
            <b-pagination size="md" :total-rows="totalPosts" v-model="currentPage" :per-page="itemsPerPage"></b-pagination>
          </div>
          <div class="col-sm-6 mt-3">
            <div class="items-per-page">
              <label for="itemsPerPage">Items per page: </label>
              <select v-model="itemsPerPage" id="itemsPerPage" v-on:change="loadNominations()" class="form-control">
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import ExportToCSV from '@/helpers/ExportToCSV.js'
import ContentHeader from '@/components/ContentHeader'
import NominationReportEntries from '@/components/NominationReportEntries'
import PreContentHeader from '@/components/PreContentHeader'

export default {
  components: {
    PreContentHeader,
    ContentHeader,
    NominationReportEntries
  },
  data () {
    return {
      nominations: [],
      contentReady: false,
      contentLoadError: '',
      nominationCategories: [],
      nominationCategorySelect: '-- All --',
      communityCategories: [],
      communityCategorySelect: '-- All --',
      currentPage: 1,
      totalPosts: 0,
      itemsPerPage: 100
    }
  },
  created () {
    document.title = this.$route.name + ' - ThinkTank'
    this.loadNominations()
  },
  methods: {
    getDateTime: function (val, needle, index) {
      if(val !== undefined && val !== null && val !== "" && val !== "NA") {
        return val.split(needle)[index]
      } else {
        return 'NA'
      }
    },
    getSingleNomineeInfo: function (x) {
      var nomineesInfo = { 'nomineeName': [], 'nomineeEmployeNumber': [], 'nomineeEmail': [], 'nomineeCompany': [], 'businessUnit': [], 'country': [], 'gom': [], 'projectSponsor': 'NA', 'projectSponsorApproved': 'NA', 'projectSponsorDeclinedReason': 'NA', 'projectSponsorDate': 'NA' }
      nomineesInfo.nomineeName = x.nominee_name.length ? x.nominee_name[0]: x.title.rendered
      nomineesInfo.nomineeEmployeNumber = x.nominee_employeeNumber.length ? x.nominee_employeeNumber[0] : ''
      nomineesInfo.nomineeEmail = x.nominee_slug.length ? x.nominee_slug[0].replace(/multichoice/g, '@multichoice').replace(/-/g, '.') : ''
      nomineesInfo.nomineeCompany = (x.nominee_company.length) ? x.nominee_company[0].replace(/,/g, ' ') : ''
      nomineesInfo.businessUnit = ' '
      nomineesInfo.country = ' '
      nomineesInfo.gom = ' '
      if ('employeehierarchy' in x.nominee_slug && x.nominee_slug.employeehierarchy) {
        nomineesInfo.nomineeEmail = x.nominee_slug[1]
        nomineesInfo.businessUnit = 'businessunit' in x.nominee_slug.employeehierarchy ? x.nominee_slug.employeehierarchy.businessunit[0] : ''
        nomineesInfo.country = x.nominee_slug.employeehierarchy.country[0]
        nomineesInfo.gom = x.nominee_slug.employeehierarchy.gom[0]
        if ('employeenumber' in x.nominee_slug.employeehierarchy)
          nomineesInfo.nomineeEmployeNumber = x.nominee_slug.employeehierarchy.employeenumber[0]
      }
      return nomineesInfo
    },    
    exportToCSV: function () {
      var self = this
      // Map fields of nominations array that will be converted to CSV
      const items = this.nominations.map(function (x) {
        var splitData = {}
        var nomineesDetails = self.getSingleNomineeInfo(x)
        const temp = Object.assign({}, {
          Nominator_Name: x._embedded.author[0].name,
          Nominator_Employee_Number: x.nominator_details[0][0]['employee-number'],
          Nominee_Name: nomineesDetails.nomineeName,
          Nominee_Employee_Number: nomineesDetails.nomineeEmployeNumber,
          Nominee_Email: nomineesDetails.nomineeEmail,
          GOM: nomineesDetails.gom,
          BU: nomineesDetails.businessUnit,
          Country: nomineesDetails.country,
          Award_Category: (x._embedded['wp:term'][1].length) ? x._embedded['wp:term'][1][0].name : x.title.rendered,
          Nominee_Status: x.nomination_approve_decline[0],
          Date_Of_Nomination: x.date.split('T')[0],
          Time_Of_Nomination: x.date.split('T')[1],
          Line_Manager: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Manager'))[0]['project_sponsor_email'] : '',
          Line_Manager_Approved: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Manager'))[0]['project_sponsor_status'] : '',
          Line_Manager_Reason: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Manager'))[0]['project_sponsor_comment'] : '',
          Line_Manager_Date: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? self.getDateTime(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Manager'))[0]['project_sponsor_datetime'], ' ', 0) : 'NA',
          Line_Manager_Time: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? self.getDateTime(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Manager'))[0]['project_sponsor_datetime'], ' ', 1) : 'NA',
          Exco2: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Exco2'))[0]['project_sponsor_email'] : '',
          Exco2_Approved: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Exco2'))[0]['project_sponsor_status'] : '',
          Exco2_Reason: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Exco2'))[0]['project_sponsor_comment'] : '',
          Exco2_Date: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? self.getDateTime(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Exco2'))[0]['project_sponsor_datetime'], ' ', 0) : 'NA',
          Exco2_Time: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? self.getDateTime(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Exco2'))[0]['project_sponsor_datetime'], ' ', 1) : 'NA',
          HRBP: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'HRBP'))[0]['project_sponsor_email'] : '',
          HRBP_Approved: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'HRBP'))[0]['project_sponsor_status'] : 'NA',
          HRBP_Reason: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'HRBP'))[0]['project_sponsor_comment'] : 'NA',
          HRBP_Date: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? self.getDateTime(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'HRBP'))[0]['project_sponsor_datetime'], ' ', 0) : 'NA',
          HRBP_Time: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? self.getDateTime(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'HRBP'))[0]['project_sponsor_datetime'], ' ', 1) : 'NA',
          Message: x.content.rendered.replace(/<strong>Message<\/strong>/gi, ' ').replace(/<p>/g, ' ').replace(/<\/p>/g, ' ')
        }, splitData)
        return temp
      })

      var keysOnly = []
      for (var k = 0; k < items.length; k++) {
        keysOnly = keysOnly.concat(Object.keys(items[k]))
      }

      let csvKeys = keysOnly.filter((v, i) => keysOnly.indexOf(v) === i)

      for (var i = 0; i < items.length; i++) {
        for (var j = 0; j < csvKeys.length; j++) {
          if (items[i][csvKeys[j]]) {
            items[i][csvKeys[j]] = items[i][csvKeys[j]]
          } else {
            items[i][csvKeys[j]] = ''
          }
        }
      }

      // Convert to JSON and then create CSV file for download
      let cloneItems = []
      let dupItems = JSON.parse(JSON.stringify(items))
      var iIndex = 0
      for (var u = 0; u < dupItems.length; u++) {
        if (dupItems[u].Nominee_Name.includes(' $&$ ')) {
          var nomineeNameCount = dupItems[u].Nominee_Name.split(' $&$ ')
          var nomineeEmployeNumberCount = dupItems[u].Nominee_Employee_Number.split(' $&$ ')
          var nomineeEmailCount = dupItems[u].Nominee_Email.split(' $&$ ')
          var nomineeCompanyCount = dupItems[u].GOM.split(' $&$ ')
          for (var w = 0; w < nomineeNameCount.length; w++) {
            cloneItems[iIndex] = JSON.parse(JSON.stringify(dupItems[u]))
            cloneItems[iIndex].Nominee_Name = nomineeNameCount[w]
            cloneItems[iIndex].Nominee_Employee_Number = nomineeEmployeNumberCount[w]
            cloneItems[iIndex].Nominee_Email = nomineeEmailCount[w]
            cloneItems[iIndex].GOM = nomineeCompanyCount[w]
            iIndex++
          }
        } else {
          cloneItems[iIndex] = JSON.parse(JSON.stringify(dupItems[u]))
          iIndex++
        }
      }
      console.log('items', items)
      ExportToCSV.createCSV(items, 'Recognition', 'Nominee_Name', ['Project_Sponsor', 'Project_Sponsor_Approved', 'Project_Sponsor_Reason', 'Project_Sponsor_Date', 'Project_Sponsor_Time', 'Line_Manager', 'Line_Manager_Approved', 'Line_Manager_Reason', 'Line_Manager_Date', 'Line_Manager_Time', 'Exco2', 'Exco2_Approved', 'Exco2_Reason', 'Exco2_Date', 'Exco2_Time', 'HRBP', 'HRBP_Approved', 'HRBP_Reason', 'HRBP_Date', 'HRBP_Time'])
      // ExportToCSV.createCSV(Object.values(cloneItems), 'VE_Awards_Nominations')
    },
    loadNominations: function () {
      this.contentReady = false
      WordpressRestAPI.getViewContent('archived_nomination?_embed&page=' + this.currentPage + '&per_page=' + this.itemsPerPage)
        .then(response => {
          this.totalPosts = parseInt(response.headers['x-wp-total'])
          this.nominations = response.data
          this.unfilteredNominations = response.data
          this.contentReady = true
        })
        .catch(e => {
          this.contentLoadError = 'Oops! We had a problem loading nominations. Please try again later.'
          console.error(e)
          this.contentReady = true
        })
    }
  },
  watch: {
    'currentPage' (newDetails, oldDetails) {
      this.loadNominations()
    }
  }
}
</script>

<style lang="less">
  .showHideBtn {
    padding: 4px 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/routes/ReportArchivedAwards.vue